"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipAlignment = exports.TOOLTIP_POSITION = void 0;
var TOOLTIP_POSITION = {
  TOP: 'top',
  BOTTOM: 'bottom'
};
exports.TOOLTIP_POSITION = TOOLTIP_POSITION;
var TooltipAlignment;
exports.TooltipAlignment = TooltipAlignment;

(function (TooltipAlignment) {
  TooltipAlignment["Left"] = "left";
  TooltipAlignment["Center"] = "center";
  TooltipAlignment["Right"] = "right";
})(TooltipAlignment || (exports.TooltipAlignment = TooltipAlignment = {}));